module.exports = __webpack_public_path__ + "static/img/10.b967344.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn2/10.jpg
// module id = 4vG/
// module chunks = 0